import { useTranslation } from "react-i18next";
import { MODEL_KEYS } from "../lib/constants";

const Silhouette = ({ model }) => {
  if (model === "modern") return <rect x="16" y="8" width="48" height="66" rx="2" fill="#1d1e22" />;
  if (model === "natural") return <path d="M12 76 L14 34 Q16 12 36 9 L48 8 Q66 12 68 32 L70 76 Z" fill="#8f897c" />;
  return <path d="M15 76 L15 34 A25 25 0 0 1 65 34 L65 76 Z" fill="#dcd4c4" stroke="#bfb39e" />;
};

export const ModelPicker = ({ value, onChange, prefix = "model" }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-3 gap-3" role="radiogroup" aria-label={t("wizard.step3_title")}>
      {MODEL_KEYS.map((m) => (
        <button
          type="button"
          key={m}
          role="radio"
          aria-checked={value === m}
          onClick={() => onChange(m)}
          data-testid={`${prefix}-option-${m}`}
          className={`stone-chip rounded-2xl border p-3 sm:p-4 text-start ${value === m ? "border-[var(--gold)] shadow-[0_14px_30px_-18px_rgba(120,90,40,0.7)] bg-[hsl(var(--card))]" : "hover:border-[hsl(var(--accent))]"}`}
        >
          <svg viewBox="0 0 80 80" className="h-14 w-14 sm:h-16 sm:w-16 mb-2" aria-hidden="true">
            <ellipse cx="40" cy="77" rx="34" ry="3" fill="rgba(0,0,0,0.12)" />
            <Silhouette model={m} />
          </svg>
          <p className="font-heading text-lg">{t(`models.${m}.name`)}</p>
          <p className="hidden sm:block text-xs text-[hsl(var(--muted-foreground))] mt-1 leading-snug">{t(`models.${m}.desc`)}</p>
        </button>
      ))}
    </div>
  );
};
